import { MapPin, Phone, Mail, Clock, User, MessageCircle } from 'lucide-react'
import styles from '@styles/ContactPage.module.css'
import { ref, push, set } from 'firebase/database'
import SocialLinks from '@components/SocialLinks'
import { database } from '@lib/firebase'
import Navbar from '@components/Navbar'
import { useState } from 'react'

const ContactPage = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [messageAlert, setMessageAlert] = useState('')

  const handleSubmit = e => {
    e.preventDefault()

    if (!name || !email || !message) {
      setMessageAlert('Por favor, complete todos los campos.')
      return
    }

    saveAppointment(name, email, message)
  }

  const saveAppointment = (name, email, message) => {
      const appointmentsRef = ref(database, `contactenos/${name}`)
      const newAppointmentRef = push(appointmentsRef)
      
      set(newAppointmentRef, {
        name: name,
        email: email,
        message: message,
        timestamp: new Date().toISOString()
      }).then(() => {
        setMessageAlert('Mensaje enviado con éxito. Gracias por comunicarte con nosotros.')
        setName('')
        setEmail('')
      }).catch((error) => {
        console.error('Error al guardar la cita:', error)
        setMessageAlert('Hubo un error al reservar la cita. Por favor, inténtelo de nuevo.')
      })
    }

  return (
    <div className={styles.contactPage}>
      <Navbar className={styles.contactNavbar} />
      <main className={styles.mainContent}>
        <h1 className={styles.title}>Contáctanos</h1>

        <div className={styles.contactContainer}>
          <div className={styles.contactInfo}>
            <h2>Información de Contacto</h2>
            <ul className={styles.infoList}>
              <li>
                <MapPin size={20} />
                <span>Cra. 86f #35B-16 sur, Bogotá</span>
              </li>
              <li>
                <Phone size={20} />
                <span>+57 3223110646</span>
              </li>
              <li>
                <Mail size={20} />
                <span>optinatalu@gmail.com</span>
              </li>
              <li>
                <Clock size={20} />
                <span>Lun - Sab: 10:00 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>

            <form onSubmit={handleSubmit} className={styles.contactForm}>
            <h2>Envíanos un Mensaje</h2>
              <div className={styles.formGroup}>
                <label htmlFor='name'>
                  <User size={20} />
                  Nombre:
                </label>
                <input
                  type='text'
                  id='name'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor='email'>
                  <Mail size={20} />
                  Correo Electrónico:
                </label>
                <input
                  type='email'
                  id='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor='message'>
                  <MessageCircle size={20} />
                  Mensaje:
                </label>
                <textarea
                  id='message'
                  name='message'
                  rows={5}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>
              <button type='submit' className={styles.submitButton}>
                Enviar Mensaje
              </button>
            </form>
            {messageAlert && (
              <p
                className={`${styles.messageAlert} ${
                  messageAlert.includes('éxito') ? styles.success : styles.error
                }`}
              >
                {messageAlert}
              </p>
            )}
        </div>

        <div className={styles.mapContainer}>
          <iframe
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5960.568436453333!2d-74.1629754!3d4.6364985999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9d03c9c102a5%3A0x5921a90f710e6edf!2sOptica%20natal%C3%BA!5e1!3m2!1ses-419!2sco!4v1737128848046!5m2!1ses-419!2sco'
            width='100%'
            height='450'
            style={{ border: 0 }}
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='strict-origin-when-cross-origin'
          ></iframe>
        </div>
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
    </div>
  )
}

export default ContactPage
